import { selectBuildingTimeZone } from 'store/building/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const getCurrentUserTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const useTimeZone = (): string => {
  const buildingTimeZone = useSelector(selectBuildingTimeZone);

  return useMemo(() => {
    return buildingTimeZone ?? getCurrentUserTimeZone();
  }, [buildingTimeZone]);
};
